(function employeeFileControllerDefinition() {
    'use strict';

    angular.module('EmployeeFile')
        .controller('EmployeeFileSearchModalController', [
            '$scope', '$state', '$translate', 'errorsExtend', '$q', '$modalInstance', 'documentContainerService', 'containerTypeService', 'adminContainerTypeService',
            'storageService', 'fileDownloader', 'multipleSelection', '$filter', 'authExtend', 'unitOrgId',
            function employeeFileController($scope, $state, $translate, errors, $q, $modalInstance, documentContainerService, containerTypeService, adminContainerTypeService,
                storageService, fileDownloader, multipleSelection, $filter, authExtend, unitOrgId) {

                $scope.load = function () {

                    $scope.multipleSelection = multipleSelection;
                    $scope.accordionState = {
                        isOpen: true
                    };

                    $translate(['PaginationNext', 'PaginationPrev', 'PaginationLastFem', 'PaginationFirstFem'])
                        .then(function (translated) {
                            $scope.paginatorTranslations = {
                                nextText: translated.PaginationNext,
                                previousText: translated.PaginationPrev,
                                lastText: translated.PaginationLastFem,
                                firstText: translated.PaginationFirstFem
                            };
                        });

                    $scope.data = {
                        checkAll: false,
                        selectedItems: [],
                        currentPage: 1,
                        totalItems: 0,
                        itemsPerPage: 8,
                        from: 0
                    };

                    $scope.clean();
                    $scope.find = storageService.getEmployeeFilesFilter();

                    $scope.filter = ['_nroleg', '_nom', '_ape', '_cuil'];
                    $scope.items = [];
                    $scope.systemNames = {};
                    $scope.showResult = false;

                    $scope.loadContainerType();
                };

                $scope.loadContainerType = function () {
                    var rootOu = authExtend.getOrganizationRoot();

                    adminContainerTypeService.getMetadataMappings(rootOu).then(function (result) {
                        var customContainerType = undefined;

                        for (var i = 0; i < result.length; i++) {
                            if (result[i].sourceMetadataMapping.length > 0 && result[i].targetMetadataMapping.length > 0) {
                                customContainerType = result[i];
                            }
                        }

                        if (customContainerType) {
                            if ($scope.find.employeeFileTypes.length <= 0) {
                                $scope.loadMetadata(customContainerType, true);
                            }
                        } else {
                            containerTypeService.getBySystemName("_leg").then(function (result) {
                                if ($scope.find.employeeFileTypes.length <= 0) {
                                    $scope.loadMetadata(result, false);
                                }
                            }, function (error) {
                                errors.showError(error);
                            });
                        }
                    });
                };

                $scope.loadMetadata = function (containerType, isCustomContainerType) {
                    if (isCustomContainerType) {
                        containerType.targetMetadataMapping.forEach(function (item, index) {
                            if ($scope.filter.indexOf(item.metadataSystemName) >= 0) {
                                $scope.systemNames[item.metadataSystemName] = {
                                    sn: containerType.sourceMetadataMapping[index].metadataSystemName,
                                    label: containerType.sourceMetadataMapping[index].metadataLabel,
                                    visible: containerType.sourceMetadataMapping[index].isResultCriteria
                                };
                            }
                        });
                    } else {
                        containerType.metadata.forEach(function (metadata) {
                            if ($scope.filter.indexOf(metadata.metadataSystemName) >= 0) {
                                $scope.systemNames[metadata.metadataSystemName] = {
                                    sn: metadata.metadataSystemName,
                                    label: metadata.metadataLabel,
                                    visible: metadata.isResultCriteria
                                };
                            }
                        });
                    }

                    var type = {
                        SystemName: containerType.systemName,
                        employeeFileTypeName: containerType.name,
                        employeeFileTypeId: containerType.id,
                        metadatas: []
                    };

                    containerType.metadata.forEach(function (metadata) {
                        var addMetadata = $scope.filter.some(function (sn) {
                            return $scope.systemNames[sn].sn === metadata.metadataSystemName;
                        });

                        if (addMetadata && metadata.isSearchCriteria) {
                            type.metadatas.push({
                                idObject: type.employeeFileTypeId + '' + metadata.metadataId,
                                metadataId: metadata.metadataId,
                                metadataValueFrom: undefined,
                                metadataValueTo: undefined,
                                metadataSearchTypeFrom: undefined, // cada control pisa el valor
                                metadataSearchTypeTo: undefined, // cada control pisa el valor
                                metadataType: metadata.metadataType,
                                metadataSystemName: metadata.metadataSystemName,
                                metadataLabel: metadata.metadataLabel,
                                metadataOptions: metadata.optionValues,
                                maskOptions: metadata.metadataMaskOption
                            });
                        }
                    });

                    $scope.find.employeeFileTypes.push(type);
                };

                $scope.clean = function () {
                    storageService.clearEmployeeFilesFilter();
                    $scope.find = storageService.getEmployeeFilesFilter();
                    $scope.items = [];
                    $scope.accordionState.isOpen = true;
                    $scope.showResult = false;
                    $scope.loadContainerType();
                };

                $scope.actionFind = function () {
                    $scope.items = [];
                    $scope.employeeFileTypes = [];
                    $scope.showResult = false;

                    if (!$scope.searchDocuments.$valid || $scope.find.employeeFileTypes.length <= 0) {
                        $scope.searchDocuments.$setSubmitted();
                        errors.showError('VerifyFormData');
                        return false;
                    }

                    return $scope.findEmployeeFiles();
                };

                $scope.cancel = function () {
                    $modalInstance.close(null);
                };

                $scope.select = function () {
                    var selectedEmployeeFile = null;
                    if (multipleSelection) {
                        selectedEmployeeFile = [];
                    }

                    $scope.data.selectedItems.forEach(function (item) {
                        if (item.check) {
                            if (multipleSelection) {
                                selectedEmployeeFile.push(item);
                            } else {
                                selectedEmployeeFile = item;
                            }
                        }
                    });

                    if (selectedEmployeeFile || (Array.isArray(selectedEmployeeFile) && selectedEmployeeFile.length > 0)) {
                        var headers = [];
                        $scope.headers.forEach(function (item) {
                            headers.push(item.label);
                        });

                        $modalInstance.close(multipleSelection ? { headers: headers, items: selectedEmployeeFile } : selectedEmployeeFile);
                    } else {
                        errors.showError('EmployeeFilAtLeastOneChecked');
                    }
                };

                $scope.selectAll = function () {
                    var filters = {
                        Complete: true,
                        ContainerTypes: [],
                        OrganizationUnitIds: unitOrgId ? [unitOrgId] : undefined
                    };

                    $scope.find.employeeFileTypes.forEach(function (type) {
                        type.Page = 1;
                        type.ItemPerPage = 0;
                        type.DocumentTypeId = type.employeeFileTypeId;
                        type.OrganizationUnitIds = unitOrgId ? [unitOrgId] : undefined;
                        filters.ContainerTypes.push(type);
                    });

                    return documentContainerService.advancedGet(filters).then(function (result) {
                        if (result && result.values.length > 0) {
                            $scope.filterItems(result);

                            var headers = [];
                            $scope.headers.forEach(function (item) {
                                headers.push(item.label);
                            });

                            $modalInstance.close({ headers: headers, items: $scope.items });
                        } else {
                            errors.showError('EmployeeFileNothingToAdd');
                        }
                    }, function getError(error) {
                        errors.showError(error);
                    });
                };

                $scope.findEmployeeFiles = function () {
                    storageService.setEmployeeFilesFilter($scope.find);

                    var filters = {
                        Complete: true,
                        ContainerTypes: [],
                        OrganizationUnitIds: unitOrgId ? [unitOrgId] : undefined
                    };

                    $scope.find.employeeFileTypes.forEach(function (type) {
                        type.Page = 1;
                        type.ItemPerPage = $scope.data.itemsPerPage;
                        type.DocumentTypeId = type.employeeFileTypeId;
                        type.OrderBy = [
                            "m." + $scope.systemNames._ape.sn + "_l",
                            "m." + $scope.systemNames._nom.sn + "_l"
                        ];

                        type.OrganizationUnitIds = unitOrgId ? [unitOrgId] : undefined;
                        filters.ContainerTypes.push(type);
                    });

                    return documentContainerService.advancedGet(filters).then(function (result) {
                        $scope.filterItems(result);

                        if ($scope.items.length > 0) {
                            $scope.accordionState.isOpen = false;
                        }

                        $scope.employeeFileTypes = result.documentTypes;
                        if ($scope.employeeFileTypes.length > 0) {
                            $scope.employeeFileTypes[0].selected = true;
                            $scope.currentSelectedTypeIsShareable = $scope.employeeFileTypes[0].isShareable;
                        }

                        $scope.data.totalItems = result.valuesCount;
                        $scope.data.from = result.valuesFrom;
                        $scope.data.currentPage = 1;
                        $scope.showResult = true;
                        $scope.showPanel();
                    }, function getError(error) {
                        errors.showError(error);
                    });
                };

                $scope.filterItems = function (result) {
                    $scope.headers = [];
                    $scope.items = [];

                    for (var i = 0; i < result.values.length; i++) {
                        $scope.items.push({
                            id: result.values[i].id,
                            organizationalUnitName: result.values[i].organizationalUnitName,
                            organizationalUnitId: result.values[i].organizationalUnitId,
                            check: false,
                            metadata: []
                        });

                        var indices = [];

                        for (var j = 0; j < $scope.filter.length; j++) {
                            var idx = result.headers.indexOf($scope.systemNames[$scope.filter[j]].label);
                            if (idx >= 0 && idx < result.values[i].metadata.length) {
                                $scope.systemNames[$scope.filter[j]].idx = idx;
                                indices.push(idx);
                            }
                        }

                        indices.sort(function (a, b) { return a - b; });

                        for (var j = 0; j < indices.length; j++) {
                            $scope.items[i].metadata.push(result.values[i].metadata[indices[j]]);
                        }
                    }

                    for (var k in $scope.systemNames) {
                        if ($scope.systemNames[k].visible) {
                            $scope.headers.push({
                                idx: $scope.systemNames[k].idx || 0,
                                systemName: $scope.systemNames[k].sn,
                                label: $scope.systemNames[k].label,
                            });
                        }
                    }

                    $scope.headers.sort(function (a, b) { return a.idx - b.idx; });
                };

                $scope.checkUnCheckAll = function () {
                    if ($scope.items.length > 0) {
                        $scope.items.forEach(function (item) {
                            item.check = $scope.data.checkAll;

                            if ($scope.data.checkAll) {
                                $scope.data.selectedItems.push(item);
                            } else {
                                var resultItem = $filter('filter')($scope.data.selectedItems, { id: item.id }, true);

                                if (resultItem.length > 0) {
                                    var index = $scope.data.selectedItems.indexOf(resultItem[0]);
                                    if (index >= 0) {
                                        $scope.data.selectedItems.splice(index, 1);
                                    }
                                }
                            }
                        });
                    }
                };

                $scope.updateSelection = function (position, item) {
                    if (!multipleSelection) {
                        angular.forEach($scope.items, function (docu, index) {
                            if (position != index) {
                                docu.check = false;
                            }
                            else {
                                $scope.data.selectedItems = [];
                                $scope.data.selectedItems.push(item);
                            }
                        });
                    } else {
                        if (item.check) {
                            $scope.data.selectedItems.push(item);
                        } else {
                            var resultItem = $filter('filter')($scope.data.selectedItems, { id: item.id }, true);

                            if (resultItem.length > 0) {
                                var index = $scope.data.selectedItems.indexOf(resultItem[0]);
                                if (index >= 0) {
                                    $scope.data.selectedItems.splice(index, 1);
                                }
                            }
                        }
                    }
                };

                $scope.showPanel = function () {
                    $scope.panelOpen = true;
                };

                $scope.hidePanel = function () {
                    $scope.panelOpen = false;
                };

                $scope.pageFind = function () {
                    $scope.items = [];
                    var find = storageService.getEmployeeFilesFilter();

                    if (find.employeeFileTypes.length <= 0) {
                        $scope.data.totalItems = 0;
                        errors.showError('VerifyFormData');
                        return;
                    }

                    var filters = {
                        PartialQuery: true,
                        ContainerTypes: [],
                        OrganizationUnitIds: unitOrgId ? [unitOrgId] : undefined
                    };

                    find.employeeFileTypes.forEach(function (type) {
                        type.Page = $scope.data.currentPage;
                        type.ItemPerPage = $scope.data.itemsPerPage;
                        type.DocumentTypeId = type.employeeFileTypeId;
                        type.OrderBy = [
                            "m." + $scope.systemNames._ape.sn + "_l",
                            "m." + $scope.systemNames._nom.sn + "_l"
                        ];

                        type.OrganizationUnitIds = unitOrgId ? [unitOrgId] : undefined;
                        filters.ContainerTypes.push(type);
                    });

                    return documentContainerService.advancedGet(filters).then(function getOk(result) {
                        $scope.filterItems(result);

                        $scope.items.forEach(function (item) {
                            var resultItem = $filter('filter')($scope.data.selectedItems, { id: item.id }, true);

                            item.check = resultItem.length > 0;
                        });

                        var resultCheck = $filter('filter')($scope.items, { check: true }, true);
                        $scope.data.checkAll = resultCheck.length > 0 && resultCheck.length == $scope.items.length;

                        if ($scope.items.length > 0) {
                            $scope.accordionState.isOpen = false;
                        }

                        $scope.data.totalItems = result.valuesCount;
                        $scope.data.from = result.valuesFrom;
                    }, function getError(error) {
                        errors.showError(error);
                    });
                };

                $scope.load();

            }]);
})();